<template>
    <form action="" method="POST" @submit.prevent="submit" novalidate>
        <div class="card-wrapper">
            <p class="headline-xs text-bold text-centered">{{ __('Where did you learn about Vitadio?') }} 😉</p>

            <div
                v-for="(index) in survey.length"
                type="button"
                :class="['card', {'active': survey[index - 1] === choosenSurvey, 'card--with-input': survey[index - 1] === 'Anderes'}]"                    
                :key="index"
                @click="chooseSurvey(survey[index - 1])"
            >
                <div class="card-inner">
                    <span class="text-big">{{ __(survey[index - 1]) }}</span>
                    <figure>
                        <span v-if="survey[index - 1] === choosenSurvey" class="material-symbols-rounded">check</span>
                        <span v-else></span>
                    </figure>  
                </div>      

                <div class="card-form" v-if="survey[index - 1] === 'Other' && choosenSurvey === 'Other'">
                    <form-input-type-text-area
                        name="learnt_about_vitadio_from"
                        :label="__('Please type your answer')"
                        :errors="errors.learnt_about_vitadio_from"
                        auto-grow
                    ></form-input-type-text-area>

                    <v-button :label="__('Send')" type="submit"></v-button>
                </div>    
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                choosenSurvey: null,
                formId: null,
                errors: [],
                survey: [
                    'Press',
                    'Social media',
                    'Internet research',
                    'Sales staff',
                    'Other'
                ],
            }
        },
        mounted() {
            let uri = new URI(location.href)
            if(window.locale === 'de') {
                this.formId = uri.pathname().replace("/fachkreise-success/", "")
            }
            
            if(window.locale === 'it') {
                this.formId = uri.pathname().replace("/operatore-sanitario-success/", "")
            }
        },
        methods: {
            chooseSurvey(learnt_about_vitadio_from) {
                this.choosenSurvey = learnt_about_vitadio_from

                if(learnt_about_vitadio_from !== 'Other') {
                    this.submit()
                }
            },
            submit() {
                var formData = {}

                let uri = new URI(location.href)
                let url = uri.protocol()+'://'+uri.hostname()

                if(this.choosenSurvey === 'Other') {
                    formData.learnt_about_vitadio_from = $('#learnt_about_vitadio_from').val()
                } else {
                    formData.learnt_about_vitadio_from = this.choosenSurvey
                }

                axios
                    .post(url+'/api/doctor-contact-form/'+this.formId, formData, {
                        headers: {
                            'Accept-Language': window.locale
                        }
                    })
                    .then((e) => {
                        $('#modal-success').modal('show')
                    })
                    .catch((e) => {
                        console.log(e.response)
                        this.errors = e.response.data.errors
                    })
            }
        }
    }
</script>
